module.exports = __webpack_public_path__ + "reduce-costs.axU_z8sV.svg";